import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-content-wrapper',
    templateUrl: './app-content-wrapper.component.html',
    styleUrls: ['./app-content-wrapper.component.scss'],
    standalone: false
})
export class AppContentWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
